module.exports = __webpack_public_path__ + "static/media/image_banner_xiao.4c1be8e8.png";